import { render, staticRenderFns } from "./HeaderHelpCenterButton.vue?vue&type=template&id=12618b83&scoped=true"
import script from "./HeaderHelpCenterButton.vue?vue&type=script&lang=js"
export * from "./HeaderHelpCenterButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12618b83",
  null
  
)

export default component.exports